'use client';
import React from 'react';
import Link from 'next/link';
import StatusBadge from '@/components/ui/StatusBadge';
import { Users, ChevronRight } from 'lucide-react';

// Backend integration: replace with /api/jobs?status=active&limit=8
const jobs = [
  { id: 'FJ-2841', client: 'Permian Basin Resources', site: 'Site C, Odessa TX', type: 'Rig Setup', status: 'in-transit', crew: 4, eta: '+22 min', scheduled: '13:00', assets: 3 },
  { id: 'FJ-2838', client: 'Desert Star Drilling', site: 'Block 14, Andrews TX', type: 'Equipment Haul', status: 'on-site', crew: 2, eta: 'On Site', scheduled: '11:30', assets: 2 },
  { id: 'FJ-2836', client: 'Lone Star Energy', site: 'Pad 7, Pecos TX', type: 'Maintenance', status: 'on-site', crew: 3, eta: 'On Site', scheduled: '10:00', assets: 1 },
  { id: 'FJ-2833', client: 'West Texas Midstream', site: 'Compressor Stn 3', type: 'Inspection', status: 'returning', crew: 2, eta: '~18 min', scheduled: '08:00', assets: 1 },
  { id: 'FJ-2829', client: 'Reyes Oilfield Svcs', site: 'FM 1788, Midland TX', type: 'Crew Transport', status: 'in-transit', crew: 6, eta: '+5 min', scheduled: '13:30', assets: 2 },
  { id: 'FJ-2825', client: 'Horizon Drilling LLC', site: 'Pad 12, Loving County', type: 'Rig Teardown', status: 'on-site', crew: 5, eta: 'On Site', scheduled: '09:00', assets: 4 },
];

const etaClass = (eta: string) => {
  if (eta.startsWith('+')) return 'text-red-400';
  if (eta === 'On Site') return 'text-emerald-400';
  return 'text-zinc-400';
};

export default function ActiveJobsTable() {
  return (
    <div className="bg-zinc-900 border border-zinc-800 rounded-xl flex flex-col h-full">
      <div className="flex items-center justify-between px-5 py-4 border-b border-zinc-800">
        <div>
          <h3 className="text-sm font-semibold text-zinc-200">Active Jobs</h3>
          <p className="text-xs text-zinc-500 mt-0.5">{jobs.length} jobs in progress</p>
        </div>
        <Link href="/job-management" className="text-xs text-amber-400 hover:text-amber-300 flex items-center gap-1 transition-colors">
          View all <ChevronRight size={12} />
        </Link>
      </div>
      <div className="overflow-x-auto scrollbar-thin flex-1">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-zinc-800">
              <th className="text-left px-4 py-2.5 text-[11px] font-semibold uppercase tracking-wider text-zinc-500">Job ID</th>
              <th className="text-left px-4 py-2.5 text-[11px] font-semibold uppercase tracking-wider text-zinc-500">Client</th>
              <th className="text-left px-4 py-2.5 text-[11px] font-semibold uppercase tracking-wider text-zinc-500">Type</th>
              <th className="text-left px-4 py-2.5 text-[11px] font-semibold uppercase tracking-wider text-zinc-500">Status</th>
              <th className="text-left px-4 py-2.5 text-[11px] font-semibold uppercase tracking-wider text-zinc-500">Crew</th>
              <th className="text-left px-4 py-2.5 text-[11px] font-semibold uppercase tracking-wider text-zinc-500">ETA</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-zinc-800/50">
            {jobs.map((job) => (
              <tr key={job.id} className="hover:bg-zinc-800/40 transition-colors group">
                <td className="px-4 py-2.5">
                  <span className="font-mono text-xs text-amber-400">{job.id}</span>
                </td>
                <td className="px-4 py-2.5">
                  <p className="text-xs font-medium text-zinc-200 truncate max-w-[140px]">{job.client}</p>
                  <p className="text-[10px] text-zinc-500 truncate max-w-[140px]">{job.site}</p>
                </td>
                <td className="px-4 py-2.5 text-xs text-zinc-400">{job.type}</td>
                <td className="px-4 py-2.5">
                  <StatusBadge status={job.status as any} />
                </td>
                <td className="px-4 py-2.5">
                  <span className="flex items-center gap-1 text-xs text-zinc-400">
                    <Users size={11} /> {job.crew}
                  </span>
                </td>
                <td className={`px-4 py-2.5 text-xs font-semibold font-mono ${etaClass(job.eta)}`}>{job.eta}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}